<template>
    <div class="preview-image-map-message">
        <div class="image-container">
            <img :src="baseUrl" alt="Preview Image Map" />
        </div>
    </div>
</template>

<script>
export default {
  name: 'ImageMapMessagePreview',
  props: {
    baseUrl: {
      type: String,
      required: true,
      default: '',
    }
  },
};
</script>

<style lang="scss" scoped>
.preview-image-map-message{
    padding-bottom: 14px;
    .image-container{
        width: 100%;
        height: auto;
        img{
            width: 100%;
            height: auto;
            border-radius: 4px;
        }
    }
}
</style>
